import { render, staticRenderFns } from "./ResourceRow.vue?vue&type=template&id=0a6bfe69&scoped=true&"
import script from "./ResourceRow.vue?vue&type=script&lang=js&"
export * from "./ResourceRow.vue?vue&type=script&lang=js&"
import style0 from "./ResourceRow.vue?vue&type=style&index=0&id=0a6bfe69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6bfe69",
  null
  
)

export default component.exports